import { useState } from 'react';
import '../../owner/ownerPages.css';
import '../../owner/subscriptions/subscriptions.css';
import './branches.css';

const emptyForm = {
  name: '',
  location: '',
  address: '',
  manager: '',
  phone: '',
  status: 'active',
};

function BranchForm({ initialData, onSubmit, onCancel, submitLabel }) {
  const [form, setForm] = useState({ ...emptyForm, ...initialData });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit?.(form);
  };

  return (
    <form className="subscription-form" onSubmit={handleSubmit}>
      <div className="branch-form-grid">
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="name">Branch Name</label>
          <input
            id="name"
            name="name"
            className="owner-form-input"
            value={form.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="location">Location</label>
          <input
            id="location"
            name="location"
            className="owner-form-input"
            value={form.location}
            onChange={handleChange}
            required
          />
        </div>
        <div className="owner-form-group branch-form-full">
          <label className="owner-form-label" htmlFor="address">Address</label>
          <textarea
            id="address"
            name="address"
            className="owner-form-input owner-form-textarea"
            rows={3}
            value={form.address}
            onChange={handleChange}
            required
          />
        </div>
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="manager">Manager</label>
          <input
            id="manager"
            name="manager"
            className="owner-form-input"
            value={form.manager}
            onChange={handleChange}
            required
          />
        </div>
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="phone">Phone</label>
          <input
            id="phone"
            name="phone"
            type="tel"
            className="owner-form-input"
            value={form.phone}
            onChange={handleChange}
            required
          />
        </div>
        <div className="owner-form-group">
          <label className="owner-form-label" htmlFor="status">Status</label>
          <select
            id="status"
            name="status"
            className="owner-form-select"
            value={form.status}
            onChange={handleChange}
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
      </div>

      <div className="subscription-form-actions">
        <button type="submit" className="owner-btn owner-btn-primary">
          {submitLabel}
        </button>
        {onCancel && (
          <button type="button" className="owner-btn owner-btn-secondary" onClick={onCancel}>
            Cancel
          </button>
        )}
      </div>
    </form>
  );
}

export default BranchForm;
